import { ServiceTypeSlug } from '@rover/types/src/ServiceType';

const getServiceType = (
  isCatOnly: boolean,
  serviceType: ServiceTypeSlug,
  suggestedPetType: string
): ServiceTypeSlug => {
  if (isCatOnly) return ServiceTypeSlug.DROP_IN;
  if (isCatOnly && suggestedPetType !== 'any') return ServiceTypeSlug.OVERNIGHT_BOARDING;

  return serviceType;
};
export default getServiceType;
